import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faSearch, faCarSide } from '@fortawesome/free-solid-svg-icons';

import Logo from '../../assets/img/sobre-rodas.png';
import './styles.css';

// 404: a pagina pedida nao existe. Leva de volta ao que o visitante pode querer.
export default function NotFound() {
  const history = useHistory();
  const canGoBack = typeof window !== 'undefined' && window.history.length > 1;

  return (
    <main className='nf-page'>
      <Link to='/' className='nf-logo' aria-label='Sobre Rodas, página inicial'>
        <img src={Logo} alt='Sobre Rodas' />
      </Link>

      <section className='nf-card' aria-labelledby='nf-title'>
        <span className='nf-code' aria-hidden='true'>404</span>
        <svg className='nf-road' viewBox='0 0 320 64' aria-hidden='true'>
          <path d='M0 44 C 80 44, 110 20, 160 20 S 240 44, 320 44' />
          <path className='nf-road-dash' d='M0 44 C 80 44, 110 20, 160 20 S 240 44, 320 44' />
          <circle className='nf-pin' cx='160' cy='20' r='7' />
        </svg>
        <p className='nf-eyebrow'>Página não encontrada</p>
        <h1 id='nf-title'>Essa rota não leva a lugar nenhum</h1>
        <p className='nf-text'>O endereço pode ter mudado ou o link estar incompleto. Escolha um caminho abaixo para seguir viagem.</p>

        <div className='nf-actions'>
          <Link to='/' className='nf-btn nf-btn-primary'>Ir para o início</Link>
          {canGoBack && (
            <button type='button' className='nf-btn nf-btn-secondary' onClick={() => history.goBack()}>
              <FontAwesomeIcon icon={faArrowLeft} aria-hidden='true' />
              Voltar
            </button>
          )}
        </div>

        <ul className='nf-links'>
          <li>
            <Link to='/companies'>
              <FontAwesomeIcon icon={faSearch} aria-hidden='true' />
              Buscar oficinas
            </Link>
          </li>
          <li>
            <Link to='/client/login'>
              <FontAwesomeIcon icon={faCarSide} aria-hidden='true' />
              Entrar na minha garagem
            </Link>
          </li>
        </ul>
      </section>
    </main>
  );
}
